<template>
  <GmapMap
    ref="map"
    :center="defaultCenter"
    :zoom="this.zoomLevel"
    :options="options"
    @dragend="updateCenter">
    <map-marker ref="mapMarker" />
  </GmapMap>
</template>

<script>
import { mapGetters } from 'vuex'
import { gmapApi } from 'vue2-google-maps'
import MapMarker from './MapMarker'

export default {
  components: {
    MapMarker
  },
  props:{
    zoomLevel: {
      type: Number,
      required:false,
      default:15
    },
    minZoom: {
      type: Number,
      required: false,
      default: 10
    },
    maxZoom: {
      type: Number,
      required: false,
    }
  },
  mounted () {
    this.$refs.map.$mapPromise.then((map) => {
      this.$store.dispatch('googleMap/updateMap', { map: map, api: this.google})
    })
  },
  data () {
    return {
      options: {
        gestureHandling: 'greedy',
        fullscreenControl: false,
        mapTypeControl: false,
        scaleControl: true,
        zoomControl: false,
        streetViewControl: false,
        clickableIcons: false,
        zoom: this.zoomLevel,
        minZoom : this.minZoom,
        maxZoom : this.maxZoom,
        styles: [{
          featureType: 'poi.business',
          stylers: [
            { visibility: 'off' }
          ]
        },
        {
          featureType: 'transit.station.bus',
          stylers: [
            { visibility: 'off' }
          ]
        }]
      },
      defaultCenter: null
    }
  },
  created () {
    this.defaultCenter = this.$store.getters['map/getCenter']
  },
  methods: {
    updateCenter: function () {
      this.$refs.map.$mapPromise
        .then((map) => {
          const params = {
            lat: map.center.lat(),
            lng: map.center.lng()
          }
          this.$store.dispatch('map/updateCenter', params)
        })
    },
    mapInitialized: function () {
      this.$refs.mapMarker.mapInitialized()
    },
    fitBoundsPlan: function () {
      this.$refs.mapMarker.fitBoundsPlan()
    }
  },
  computed: {
    ...mapGetters({
      center: 'map/getCenter',
      zoom: 'map/getZoom'
    }),
    google: gmapApi
  }
}
</script>
